/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthMyGamesTokenDataFromJSON, FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthMyGamesTokenDataToJSON, } from './FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthMyGamesTokenData';
import { FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferStateFromJSON, FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferStateToJSON, } from './FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState';
import { FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataFromJSON, FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataToJSON, } from './FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameData';
/**
 * Check if a given object implements the FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthData interface.
 */
export function instanceOfFxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthData(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    if (!('AccountId' in value) || value['AccountId'] === undefined)
        return false;
    if (!('MyGamesTokenData' in value) || value['MyGamesTokenData'] === undefined)
        return false;
    if (!('TransferState' in value) || value['TransferState'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataFromJSON(json) {
    return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Token': json['Token'],
        'AccountId': json['AccountId'],
        'Email': json['Email'] == null ? undefined : json['Email'],
        'MyGamesTokenData': FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthMyGamesTokenDataFromJSON(json['MyGamesTokenData']),
        'GameData': json['GameData'] == null ? undefined : FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataFromJSON(json['GameData']),
        'TransferState': FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferStateFromJSON(json['TransferState']),
    };
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataToJSON(json) {
    return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Token': value['Token'],
        'AccountId': value['AccountId'],
        'Email': value['Email'],
        'MyGamesTokenData': FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthMyGamesTokenDataToJSON(value['MyGamesTokenData']),
        'GameData': FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataGameDataToJSON(value['GameData']),
        'TransferState': FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferStateToJSON(value['TransferState']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthData.js.map